// DS: i12.4
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioStash: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M4.3 6.8v5.65h7.4V6.8zM3.5 5a1 1 0 0 0-1 1v7.25a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm6 3h-3a.75.75 0 0 0-.09 1.5H9.5A.75.75 0 0 0 9.59 8h-.1ZM14 1.75c.37 0 .67.27.67.6v.6c0 .33-.3.6-.67.6H2c-.37 0-.67-.27-.67-.6v-.6c0-.33.3-.6.67-.6z"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};
StudioStash.displayName = 'StudioStash';

export default StudioStash;
